import type { SerializedEstablishment } from '@enmon/commons/lib/enmon';
import { BaseApiClient } from '@/services/baseApiClient';
import type { CountableApiResponse } from '@/types/api/responses';
import type { Gateway } from '@enmon/commons/lib/meters/gateway';
import { getQuery } from '@/components/filter/helpers';
import type { StrictOmit } from '@enmon/commons';
import type { RequestOptions } from '@/utils/request';

// TODO: update Gateway entity type to be serializable
export interface SerializedGateway extends StrictOmit<Gateway, '_id' | 'meters'> {
  readonly _id: string;
  meters?: string[];
}

type GetGatewaysResponse = CountableApiResponse<SerializedGateway[]>;

export interface GatewaysFilter {
  establishments?: SerializedEstablishment['_id'];
}

export interface IGatewaysApiClient {
  get(filter: GatewaysFilter, signal: RequestOptions['signal']): Promise<GetGatewaysResponse | null>;
}

export class GatewaysApiClient extends BaseApiClient implements IGatewaysApiClient {
  constructor() {
    super('api/gateways');
  }

  public get(filter: GatewaysFilter, signal: RequestOptions['signal']): Promise<GetGatewaysResponse | null> {
    return this.http.get('', {
      query: getQuery(filter),
      signal,
    });
  }
}
